import { PaginatedRequest } from '../types/api';
import {
  CreatePromoCodeRequest,
  CreatePromoCodeResponse,
  FetchPromoCodesResponse,
  FetchPromoCodeUsagesResponse,
  UpdatePromoCodeRequest,
  UpdatePromoCodeResponse,
} from '../types/promoCodes';
import { toQueryParams } from '../utils/request';
import { ApiService } from './common/ApiService';

class PromoCodeService extends ApiService {
  pathname = 'admin/referral-code';

  fetchPromoCodes = async (data: PaginatedRequest) =>
    this.get<FetchPromoCodesResponse>(`${this.pathname}?${toQueryParams(data)}`);

  fetchPromoCodeUsages = async (data: PaginatedRequest) => {
    const { id, ...queryData } = data;
    return this.get<FetchPromoCodeUsagesResponse>(`${this.pathname}-usage/${id}?${toQueryParams(queryData)}`);
  };

  createPromoCode = async (promoCode: CreatePromoCodeRequest) =>
    this.post<CreatePromoCodeResponse, CreatePromoCodeRequest>(`${this.pathname}`, promoCode);

  updatePromoCode = async ({ id, ...promoCode }: UpdatePromoCodeRequest) =>
    this.put<UpdatePromoCodeResponse, Omit<UpdatePromoCodeRequest, 'id'>>(`${this.pathname}/${id}`, promoCode);
}

export const promoCodeService = new PromoCodeService();
